<section class="container">
  <div *ngIf="!loading">
    <div class="tools-right" *ngIf="isReloadAvailable">
      <button
        avButton
        ofType="basic"
        class="fx-row fx-align-center"
        (click)="getInteractions()"
      >
        <av-icon size="xs" name="reload"></av-icon>
        {{ "Refresh" | translate }}
      </button>
    </div>
    <ng-container *ngIf="isInitialized">
      <div class="step text-center">
        <div class="panel-container">
          <av-card type="info" *ngIf="isHelpVisible">
            <av-card-body size="xs">
              <h3 class="container-pad-md" translate>
                Please enable one of the available actions in the settings page.
              </h3>
            </av-card-body>
          </av-card>

          <!-- schedule -->
          <div class="panel-container-secondary">
            <ng-container *ngIf="isSchedulingAvailable">
              <av-tooltip
                *ngIf="isActiveActionEmpty()"
                [message]="
                  isSchedulingNotConfigured
                    ? 'Go to settings to configure'
                    : 'Schedule a video call'
                "
                position="top"
                [class.panel-button-callback]="
                  isVideoCallAvailable ||
                  isCobrowseAvailable ||
                  isScreenShareAvailable
                "
              >
                <button
                  [disabled]="isSchedulingDisabled"
                  class="launch-button"
                  [attr.aria-label]="'Schedule a video call' | translate"
                  (click)="toggleCallback()"
                  data-tid="welcome/launch-callback"
                  id="btn-callback"
                  (mousedown)="onMouseDown('calendar')"
                  (mouseup)="onMouseUp()"
                  (mouseleave)="onMouseUp()"
                >
                  <div class="launch-button-body">
                    <av-icon
                      [mode]="iconActive() === 'calendar' ? 'light' : 'dark'"
                      name="calendar-time-thin"
                    ></av-icon>
                  </div>
                </button>
              </av-tooltip>
              <app-callback
                *ngIf="isCallbackVisible()"
                [inCall]="false"
                [hover]="false"
                (close)="toggleCallback()"
              >
              </app-callback>
            </ng-container>

            <ng-container *ngIf="isAssistantAvailable()">
              <av-tooltip
                *ngIf="isActiveActionEmpty()"
                message="AI Agent"
                position="bottom"
                [class.panel-button-assistant]="
                  isVideoCallAvailable ||
                  isCobrowseAvailable ||
                  isScreenShareAvailable
                "
              >
                <button
                  class="launch-button"
                  [attr.aria-label]="'AI Agent' | translate"
                  (click)="openAssistant()"
                  data-tid="welcome/launch-assistant"
                  (mousedown)="onMouseDown('assistant')"
                  (mouseup)="onMouseUp()"
                  (mouseleave)="onMouseUp()"
                >
                  <div class="launch-button-body">
                    <av-icon
                      [mode]="iconActive() === 'assistant' ? 'light' : 'dark'"
                      name="assistant"
                    ></av-icon>
                  </div>
                </button>
              </av-tooltip>
            </ng-container>
          </div>

          <!-- <button (click)="test()">
            test chat message
          </button> -->
          <!-- audio/video call -->
          <button
            *ngIf="isActiveActionEmpty() && isVideoCallAvailable"
            [class.ripple-container]="isCallEnabled"
            class="launch-button"
            [disabled]="!isCallEnabled"
            data-tid="welcome/launch-conference"
            [attr.aria-label]="'Start a video call' | translate"
            (click)="startCall()"
            (mousedown)="onMouseDown('call')"
            (mouseup)="onMouseUp()"
            (mouseleave)="onMouseUp()"
            #callBtn
            autofocus
          >
            <div class="launch-button-body" id="btn-generate-room-and-join">
              <ng-container *ngIf="!isCallLoading()">
                <av-icon
                  *ngIf="!isConversationAudio"
                  [mode]="iconActive() === 'call' ? 'light' : 'dark'"
                  name="cam"
                ></av-icon>
                <av-icon
                  *ngIf="isConversationAudio"
                  [mode]="iconActive() === 'call' ? 'light' : 'dark'"
                  name="mic"
                ></av-icon>
              </ng-container>
              <av-spinner
                *ngIf="isCallLoading()"
                size="md"
                mode="dark"
              ></av-spinner>
            </div>
          </button>

          <div class="panel-container-secondary">
            <!-- cobrowse -->
            <ng-container *ngIf="isCobrowseAvailable">
              <av-tooltip
                position="bottom"
                *ngIf="isActiveActionEmpty()"
                [class.panel-button-cobrowse]="isVideoCallAvailable"
                message="Start a co-browse session"
              >
                <button
                  class="launch-button"
                  [disabled]="isCobrowseDisabled"
                  (click)="toggleCobrowse()"
                  data-tid="welcome/launch-cobrowse"
                  [attr.aria-label]="'Start a co-browse session' | translate"
                  autofocus
                  (mousedown)="onMouseDown('cobrowse')"
                  (mouseup)="onMouseUp()"
                  (mouseleave)="onMouseUp()"
                >
                  <div
                    class="launch-button-body"
                    id="btn-cobrowse"
                    data-tid="welcome/launch-cobrowse"
                  >
                    <av-icon
                      name="cobrowse"
                      [mode]="iconActive() === 'cobrowse' ? 'light' : 'dark'"
                    ></av-icon>
                  </div>
                </button>
              </av-tooltip>
            </ng-container>

            <!-- screen share -->
            <ng-container *ngIf="isScreenShareAvailable">
              <av-tooltip
                position="bottom"
                *ngIf="isActiveActionEmpty()"
                [class.panel-button-display-capture]="isVideoCallAvailable"
                message="Start a Screen Share session"
              >
                <button
                  class="launch-button"
                  [disabled]="isCobrowseDisabled"
                  (click)="toggleDisplayCapture()"
                  data-tid="welcome/launch-display-capture"
                  [attr.aria-label]="'Start a Screen Share session' | translate"
                  autofocus
                  (mousedown)="onMouseDown('display-capture')"
                  (mouseup)="onMouseUp()"
                  (mouseleave)="onMouseUp()"
                >
                  <div
                    class="launch-button-body"
                    id="btn-display-capture"
                    data-tid="welcome/launch-display-capture"
                  >
                    <av-icon
                      name="cobrowse-screen"
                      [mode]="
                        iconActive() === 'display-capture' ? 'light' : 'dark'
                      "
                    ></av-icon>
                  </div>
                </button>
              </av-tooltip>
            </ng-container>
          </div>

          <app-assistant-launcher
            *ngIf="isAssistantOpen()"
            (dismiss)="assistantClosed()"
          ></app-assistant-launcher>

          <app-cobrowse-launcher
            *ngIf="
              (isCobrowseAvailable || isScreenShareAvailable) &&
              isCobrowseVisible()
            "
            [interaction]="interaction()"
            [requestType]="cobrowseRequestType()"
            (started)="cobrowseStarted($event)"
            (closed)="cobrowseCancelled()"
          ></app-cobrowse-launcher>
        </div>

        <ng-container *ngIf="isActiveActionEmpty()">
          <ng-container
            *ngIf="isOriginCall || isOriginChat || isOriginInteractionWidget"
          >
            <h1 class="title" translate>Click to create a video room</h1>
            <h3 translate>You can invite the customer once you join</h3>
          </ng-container>
          <ng-container *ngIf="isOriginWidget && !isConversationCallback">
            <ng-container *ngIf="!isConversationChat">
              <h1 translate>Hurry up! The customer is waiting.</h1>
              <ng-container *ngIf="isVideoCallAvailable">
                <h1 *ngIf="isConversationVideo" class="title" translate>
                  Click to join the video room
                </h1>
                <h1 *ngIf="isConversationAudio" class="title" translate>
                  Click to join the Voice call
                </h1>
              </ng-container>
              <ng-container *ngIf="!isVideoCallAvailable">
                <h3 *ngIf="isCobrowseAvailable" translate>
                  Start a co-browse session
                </h3>
                <h3 *ngIf="isScreenShareAvailable" translate>
                  Start a Screen Share session
                </h3>
              </ng-container>
              <h3 *ngIf="isVideoCallAvailable" translate>
                The customer will join once you join
              </h3>
            </ng-container>
            <ng-container *ngIf="isConversationChat">
              <h1 *ngIf="isVideoCallAvailable" translate>
                Click to escalate this chat session to Video Call
              </h1>
              <h1
                *ngIf="isCobrowseAvailable && !isVideoCallAvailable"
                translate
              >
                Escalate chat to Co-browse
              </h1>
              <h1
                *ngIf="isScreenShareAvailable && !isVideoCallAvailable"
                translate
              >
                Escalate chat to Screen Share
              </h1>
              <h3 translate>The customer will join once you join</h3>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isConversationCallback">
            <h1 class="title" translate>
              Click to join the scheduled video call
            </h1>
            <h3 translate>The customer is already waiting for you</h3>
          </ng-container>
          <ng-container *ngIf="!isInteractionAvailable">
            <h1 class="title">
              <span translate>Hello</span>&nbsp;<span *ngIf="!!user">{{
                name
              }}</span>
            </h1>
            <h3 *ngIf="isVideoCallAvailable" translate>
              Waiting for the next customer...
            </h3>
            <ng-container *ngIf="!isVideoCallAvailable">
              <h3 *ngIf="isCobrowseAvailable" translate>
                Start a co-browse session
              </h3>
              <h3 *ngIf="isScreenShareAvailable" translate>
                Start a Screen Share session
              </h3>
            </ng-container>
            <h3
              *ngIf="
                !isVideoCallAvailable &&
                !isCobrowseAvailable &&
                isSchedulingAvailable
              "
              translate
            >
              Schedule a video call
            </h3>
          </ng-container>
          <ng-container *ngIf="isOriginAppointment">
            <h1 class="title" translate>Click to join the appointment</h1>
            <h3 translate>The customer is already waiting for you</h3>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>
</section>
